import React from 'react';
import { InputNumber, Text, Button, ButtonHierarchies, InputSizes, TextAs, TextSizes } from '@clockout-dev/design-elements';
import { PlusCircleOutlined } from '@ant-design/icons';
import ConfigurationCard from '../../../../common/configurationCard/ConfigurationCard';
import VolumeAdvancedCapTenureRuleRow from './VolumeAdvancedCapTenureRuleRow';
import styles from '../styles/limitsForm.module.scss';

function VolumeAdvancedCapCard({
    value,
    enabled,
    onChange,
    onToggleEnabled,
    tenureRules = [],
    onAddTenureRule,
    onRemoveTenureRule,
    onUpdateTenureRule
}) {
    return (
        <ConfigurationCard
            title="Volume Advanced Cap"
            description="The maximum $ volume a user can advance in a pay cycle"
            togglePosition="leading"
            enabled={enabled}
            onToggleEnabled={onToggleEnabled}
        >
            <div className={styles.cardInputRow}>
                <InputNumber
                    size={InputSizes.SMALL}
                    value={value}
                    prefix={<Text as={TextAs.SPAN} size={TextSizes.SMALL}>$</Text>}
                    onChange={onChange}
                    min={0}
                    max={999999.99}
                    step={0.01}
                    precision={2}
                    controls={false}
                    className={`${styles.inlineNumberInput} ${styles.amountField}`}
                />
                <Text as="span" size="s" className={styles.ruleLabel}>dollars per pay cycle</Text>
            </div>

            {/* Tenure-based rules section */}
            {tenureRules && tenureRules.length > 0 && (
                <div className={styles.tenureSection}>
                    <Text as="span" size="s" className={styles.panelBlockTitle}>
                        Tenure-Based Adjustments
                    </Text>
                    {tenureRules.map((rule) => (
                        <VolumeAdvancedCapTenureRuleRow
                            key={rule.id}
                            rule={rule}
                            onUpdate={onUpdateTenureRule}
                            onRemove={onRemoveTenureRule}
                        />
                    ))}
                </div>
            )}

            {onAddTenureRule && (
                <Button
                    type="button"
                    hierarchy={ButtonHierarchies.LINK_COLOR}
                    icon={<PlusCircleOutlined />}
                    className={styles.addRowButton}
                    onClick={onAddTenureRule}
                >
                    Add tenure rule
                </Button>
            )}
        </ConfigurationCard>
    );
}

export default VolumeAdvancedCapCard;
